import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import { PDP_CTA, PRODUCT_INFO_INTERACTION, trackPDPCtaClicked, trackProductInfoInteracted } from 'data-hooks/useEvents/pdpInteractionEvents';
import PDPInfoTable from '../PDPInfoTable';
import PDPMeasureForDeliverySlideshow from '../PDPMeasureForDeliverySlideshow';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';
import PDPInfoSegmentedTabs from './PDPInfoSegmentedTabs';
const PRODUCT_SUB_TAB_ID = 'pdp-info-dimensions-product';
const SHIPPING_SUB_TAB_ID = 'pdp-info-dimensions-shipping';
const SELECTED_INTERACTION_BY_SUB_TAB = {
  [PRODUCT_SUB_TAB_ID]: PRODUCT_INFO_INTERACTION.DIMENSIONS_SELECTED,
  [SHIPPING_SUB_TAB_ID]: PRODUCT_INFO_INTERACTION.SHIPPING_DIMENSIONS_SELECTED
};
const MEASURE_FOR_DELIVERY_URL = '/fit-guide';
const MEASURE_FOR_DELIVERY_LABEL = 'Measure for delivery';

// Dimensions tab: the measurement tables on the left, Measuring for Delivery on the right
const PDPInfoDimensionsSection = t0 => {
  const $ = _c(15);
  const {
    stacked: t1
  } = t0;
  const stacked = t1 === undefined ? false : t1;
  const [chosenSubTab, setChosenSubTab] = useState(PRODUCT_SUB_TAB_ID);
  const {
    error,
    data: t2
  } = useProductAttributes();
  const {
    dimensions,
    boxDimensions
  } = t2;
  if (error) {
    return null;
  }
  const hasProductDimensions = dimensions?.length > 0;
  const hasBoxDimensions = boxDimensions?.length > 0;
  let t3;
  if ($[0] !== chosenSubTab) {
    t3 = id => {
      setChosenSubTab(id);
      if (id !== chosenSubTab) {
        trackProductInfoInteracted(SELECTED_INTERACTION_BY_SUB_TAB[id]);
      }
    };
    $[0] = chosenSubTab;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const selectSubTab = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <><PDPMeasureForDeliverySlideshow /><Link className="inline-block mt-4 text-xs font-bold text-brand no-underline hover:cursor-pointer hover:underline" to={MEASURE_FOR_DELIVERY_URL} target="_blank" data-xc="PDPMeasureForDeliveryLink" onClick={_temp}>{MEASURE_FOR_DELIVERY_LABEL}</Link></>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const aside = t4;
  let t5;
  if ($[3] !== dimensions) {
    t5 = <PDPInfoTable items={dimensions} />;
    $[3] = dimensions;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const productTable = t5;
  let t6;
  if ($[5] !== boxDimensions) {
    t6 = <PDPInfoTable items={boxDimensions} />;
    $[5] = boxDimensions;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const boxTable = t6;
  let t7;
  if ($[7] !== boxTable || $[8] !== chosenSubTab || $[9] !== hasBoxDimensions || $[10] !== hasProductDimensions || $[11] !== productTable || $[12] !== selectSubTab || $[13] !== stacked) {
    t7 = <PDPInfoSectionLayout aside={aside} asideHeading="Measuring for Delivery">{!stacked && hasProductDimensions && hasBoxDimensions ? <PDPInfoSegmentedTabs aria-label="Dimensions" items={[{
        id: PRODUCT_SUB_TAB_ID,
        label: "Dimensions",
        content: productTable
      }, {
        id: SHIPPING_SUB_TAB_ID,
        label: "Shipping Dimensions",
        content: boxTable
      }]} selectedTab={chosenSubTab} onSelectTab={selectSubTab} /> : <>{hasProductDimensions && productTable}{hasBoxDimensions && <div className={hasProductDimensions ? "[border-top:1px_solid_#e5e5e5] mt-8 pt-8" : undefined}><h4 className="text-base font-bold text-gray m-0">Shipping Dimensions</h4>{boxTable}</div>}</>}</PDPInfoSectionLayout>;
    $[7] = boxTable;
    $[8] = chosenSubTab;
    $[9] = hasBoxDimensions;
    $[10] = hasProductDimensions;
    $[11] = productTable;
    $[12] = selectSubTab;
    $[13] = stacked;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
PDPInfoDimensionsSection.propTypes = {
  stacked: PropTypes.bool
};
export default PDPInfoDimensionsSection;
function _temp() {
  return trackPDPCtaClicked({
    cta: PDP_CTA.MEASURE_FOR_DELIVERY,
    text: MEASURE_FOR_DELIVERY_LABEL,
    targetUrl: MEASURE_FOR_DELIVERY_URL
  });
}